import { Row } from 'react-table';
import { Header } from 'layout';
import { withPlaceholder } from 'HOC';
import { Employer } from 'services/requests';
import { useGetEmployers } from 'hooks/api/employer';
import { useNavigate } from 'hooks/routes';
import { useSetData } from 'hooks/cache';
import { QueryKeys } from 'constants/queryKeys';
import EmployersAddButton from './components/EmployersAddButton';
import { EmployerTableSign, mapData } from './Employers.columns';
import RenderTable from './components/RenderTable';
import messages from './Employers.messages';
import styles from './Employers.module.css';

const RenderTablewithPlaceholders = withPlaceholder(RenderTable);

const Employers = (): JSX.Element => {
  const { toIraUsersRoleAdmin } = useNavigate();
  const {
    data: employersData,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetEmployers();

  const addEmployerToCache = useSetData();

  const onEdit = (employer?: Employer) => {
    if (employer) {
      addEmployerToCache(employer, QueryKeys.employer);
    }
  };

  const items = mapData(employersData?.items, onEdit);

  const onClick = (row: Row<EmployerTableSign>): void => {
    const employer = employersData?.items[row.index];
    onEdit(employer);
    toIraUsersRoleAdmin(row.original.id.toString());
  };

  return (
    <>
      <Header title={messages.headerTitle}>
        <EmployersAddButton />
      </Header>

      <div className={styles.content}>
        <RenderTablewithPlaceholders
          employersData={employersData}
          items={items}
          onClick={onClick}
          refetch={refetch}
          isRefetching={isRefetching}
          isLoading={isLoading}
          isError={isError}
          isData={!!employersData?.context && !!items && items?.length !== 0}
        />
      </div>
    </>
  );
};

export default Employers;
